import { EBillingStatus, IInvoiceReferenceBasic } from '../billing';
import { UUID } from '../common';
import { IDigitizedDeliveryNote } from '../documentation';
import { EFreightLoadingType, EFreightTransportGoodsType, IFreightDriver, IFreightVehicle } from '../freight-common';
import { EStopStatus, EStopType, IStopBasicForShipper, IStopDetailedForShipper } from '../stop';
import { EVehicleType } from '../vehicle';
import { EFreightForShipperStatus } from './freight-shipper.enum';

// comes from FreightBasicForShipperResponse
export interface IFreightBasicForShipper {
  id: UUID;
  status: EFreightForShipperStatus; // Map from FreightStatus, not in response, add depending on which query was made
  reference: string;
  numberOfStops: number; // calculated property

  stopsBasic: IStopBasicForShipper[];
  vehicles: IFreightVehicle[];
  drivers: IFreightDriver[];
  // invoiceList: IInvoiceBasic[]; // TODO, is new

  scheduledKm?: number; // old `distance`
  price?: number; //
  billingStatus?: EBillingStatus;
  deliveryNoteInPaperRequired?: boolean; // old deliveryNoteInPaper in frontend?
  // deliveryNoteInPaperReceived?: boolean;

  offerAcceptedAt?: Date;

  nextStopId?: UUID; // calculated property
  nextStopType?: EStopType; // calculated property
  nextStopStatus?: EStopStatus; // calculated property
}

// comes from FreightDetailForShipper
export interface IFreightDetailedForShipper extends Omit<IFreightBasicForShipper, 'stopsBasic'> {
  stopsDetailed: IStopDetailedForShipper[];

  title: string; // New, calculate this
  okcargoReference: string;

  transportGoodsType: EFreightTransportGoodsType;
  vehicleTypes: EVehicleType[];
  loadingTypes: EFreightLoadingType[];
  invoiceList: IInvoiceReferenceBasic[];

  digitizedDeliveryNotes: IDigitizedDeliveryNote[];

  instructions: string;

  waste?: boolean; // "transportGoodsType": "WASTE",

  // TODO recover these?
  // deliveryNoteInPaperSentAt?: Date;
  // deliveryNoteInPaperReceivedAt?: Date;
  // temperatureMin?: number;
  // temperatureMax?: number;
  // temperatureUnit?: string;

  // TODO add in mappers (get data, send data)
  shipperSiteId: UUID; // shipperCostCenterId
  shipperSiteName: string; // shipperCostCenterId
  shipperContactId: UUID;
  shipperContactName: string;

  shipperId?: UUID; // not for now
}

export function getEmptyFreightBasicForShipper(): IFreightBasicForShipper {
  return {
    id: '',
    status: EFreightForShipperStatus.DEFAULT,
    reference: '',
    stopsBasic: [],
    drivers: [],
    vehicles: [],
    numberOfStops: 0,
  } as IFreightBasicForShipper;
}

// TODO ¿add default stops?
export function getEmptyFreightDetailForShipper(): IFreightDetailedForShipper {
  return {
    stopsDetailed: [],
    transportGoodsType: EFreightTransportGoodsType.NORMAL,
    vehicleTypes: [],
    loadingTypes: [],
    instructions: '',
    scheduledKm: 0,
    title: '',
    id: '',
    status: EFreightForShipperStatus.DEFAULT,
    reference: '',
    vehicles: [],
    drivers: [],
    numberOfStops: 0,
    invoiceList: [],
    okcargoReference: '',
    digitizedDeliveryNotes: [],
    shipperSiteId: '',
    shipperContactId: '',
    shipperSiteName: '',
    shipperContactName: '',
  } as IFreightDetailedForShipper;
}
